import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

// Public feature toggles from the admin panel. Defaults to enabled until loaded
// so a failed request never hides existing functionality.
export function useFeatures() {
  const [features, setFeatures] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/public/features").then((r) => { cache = r.data; setFeatures(r.data); }).catch(() => {});
  }, []);
  const isEnabled = (key) => features[key] !== false;
  return { features, isEnabled };
}
